import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  NgbModal,
  NgbTypeaheadSelectItemEvent,
} from "@ng-bootstrap/ng-bootstrap";
import { OperatorFunction } from "rxjs/interfaces";
import { Observable } from "rxjs/Observable";
import { debounceTime, distinctUntilChanged, mergeMap } from "rxjs/operators";

import { fromPromise } from "rxjs/observable/fromPromise";
import { TranslationService } from "../../../../_services/translation.service";
import { ITranslations } from "../../../../_models/ITranslations";
import { BudgetSection } from "../../event-page-models/budget-section";
import { EventsService } from "../../../../_services/eventsServices/events.service";

@Component({
  selector: "budget-section-search-box",
  templateUrl: "./budget-section-search-box.component.html",
  styleUrls: [
    "../../../events-screen/create-parent-event-form-pricing-row/create-parent-event-form-pricing-row.component.scss",
    "budget-section-search-box.component.scss",
  ],
})
export class BudgetSectionSearchBoxComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild("resultTemplate") public resultTemplate;
  @ViewChild("autoCompleteInput") public autoCompleteInput: ElementRef;
  public translations$: Observable<ITranslations>;

  @Output("budgetSectionSelected")
  public budgetSectionSelectedEvent: EventEmitter<BudgetSection | null> = new EventEmitter<BudgetSection | null>();
  @Input("displayAllBudgetSections") public displayAllBudgetSections: boolean =
    false;

  constructor(
    private modalService: NgbModal,
    private eventService: EventsService,
    private translationService: TranslationService
  ) {
    this.translations$ = this.translationService.translations;
  }

  public _budgetSection: BudgetSection | null = null;

  @Input("budgetSection") set budgetSection(value: BudgetSection | null) {
    this._budgetSection = value;
    if (value) {
      this.autoCompleteInput.nativeElement.value =
        value.budgetSectionDescription;
    }
  }

  public ngOnInit(): void {
    //this.eventService.searchBudgetLinesForEvent("אבי", false).then();
  }

  public searchHandler: OperatorFunction<string, any> = (
    text$: Observable<any>
  ) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      mergeMap((term): any => {
        return fromPromise(
          this.eventService.searchBudgetLinesForEvent(
            term,
            this.displayAllBudgetSections
          )
        );
      })
    );
  ///backend/django-api/budget-item-line/get_authorize_budget_item_lines/
  public formatter = (x: { name: string }) => x.name;

  public ngAfterViewInit() {}

  public ngOnDestroy(): void {}

  public getResultTemplate() {
    return this.resultTemplate;
  }

  public handleClearText($event) {
    this.autoCompleteInput.nativeElement.value = "";
  }

  public budgetSectionSelected($event: NgbTypeaheadSelectItemEvent) {
    $event.preventDefault();
    this.autoCompleteInput.nativeElement.value = "";
    const budgetSelected = $event.item as BudgetSection;

    this.budgetSectionSelectedEvent.emit({
      budgetSectionId: budgetSelected.budgetSectionId,
      budgetSectionDescription:
        budgetSelected.budgetSectionDescription || "תקציב של קן קרית אונו",
    });
  }

  public disableClick($event, stop: boolean) {
    if (!stop) {
      return;
    }
    $event.stopPropagation();
    $event.stopImmediatePropagation();
  }

  public textChanged($event: Event) {}

  public handleRemove($event: MouseEvent) {
    this.autoCompleteInput.nativeElement.value = "";
    this.budgetSectionSelectedEvent.emit(null);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/create-parent-event-form-budget-section/budget-section-search-box/budget-section-search-box.component.ts